module.exports = __webpack_public_path__ + "img/A1 (4).ba8328de.jpg";